import React, { useCallback } from "react";
import { Button } from "@euroland/base-ui";
import { Dropdown, Option } from "@euroland/dropdown-react";
import Label from "../../../../components/ui/Label";
import NumberInput from "../../../../components/ui/NumberInput";
import i18n from "../../../../locale/i18n";
import { useSelectedInstrument } from "../../../../hooks/useCompanySettings";
import useCurrencyName from "../../../../hooks/useCurrencyName";
import { isUseLatinNumber } from "../../../../store/utils";

const VictorAverageBasedCalculatorForm = ({
    formState,
    onSubmit,
    loading,
    currencyCode,
    companySettings,
}) => {
    const [, { formatNumber }] = useSelectedInstrument();
    const getCurrencyNameByCode = useCurrencyName();
    const { setFieldValue, getFieldValue } = formState;

    const handleFormatNumber = useCallback(
        (value) => formatNumber(value),
        [formatNumber]
    );

    const handleFormatNumberNoDecimalDigits = useCallback(
        (value) =>
            formatNumber(value, {
                decimalDigits: 0,
            }),
        [formatNumber]
    );

    return (
        <div className="average-based-calculator-form average-based-calculator-form--victor">
            <div className="average-based-calculator-form__row average-based-calculator-form__row--victor">
                <div className="average-based-calculator-form__item">
                    <Label htmlFor="numberOfShares">{i18n.translate("totalNumberOfSharesHeld")}</Label>
                    <NumberInput
                        useLatinNumbers={isUseLatinNumber}
                        className={formState.error?.["numberOfShares"] ? "error" : ""}
                        title={i18n.translate("totalNumberOfSharesHeld")}
                        value={getFieldValue("numberOfShares")}
                        onChange={(value) => setFieldValue("numberOfShares", value)}
                        formatNumber={handleFormatNumberNoDecimalDigits}
                        require
                        id="numberOfShares"
                        errorMessage={
                            formState.error?.["numberOfShares"]
                                ? i18n.translate("fieldRequired")
                                : ""
                        }
                    />
                </div>
                <div className="average-based-calculator-form__item">
                    <Label htmlFor="averageAmountInvested">{i18n.translate("averageAmountInvested")}</Label>
                    <NumberInput
                        useLatinNumbers={isUseLatinNumber}
                        className={
                            formState.error?.["averageAmountInvested"] ? "error" : ""
                        }
                        title={i18n.translate("averageAmountInvested")}
                        value={getFieldValue("averageAmountInvested")}
                        onChange={(value) =>
                            setFieldValue("averageAmountInvested", value)
                        }
                        formatNumber={handleFormatNumber}
                        require
                        id="averageAmountInvested"
                        errorMessage={
                            formState.error?.["averageAmountInvested"]
                                ? i18n.translate("fieldRequired")
                                : ""
                        }
                    />
                </div>
                {companySettings.currencyEnabled && (
                    <div className="average-based-calculator-form__item">
                        <Label>{i18n.translate("currency")}</Label>
                        <Dropdown
                            icon={<span className="fs-triangle-down fs-icon"></span>}
                            value={getFieldValue("currency")}
                            className="average-based-calculator-form__input"
                            placeholder={i18n.translate("localCurrency")}
                            onOptionSelect={(value) =>
                                setFieldValue("currency", value)
                            }
                            dropdownMenuLabel="dropdown currency"
                            aria-label={i18n.translate("chooseCurrency")}
                        >
                            <Option value="">
                                {i18n.translate("localCurrency")}
                            </Option>
                            {companySettings.currencies.map(({ code, text }) => (
                                <Option
                                    key={code}
                                    value={code}
                                    aria-label={getCurrencyNameByCode(code)}
                                >
                                    {text || code}
                                </Option>
                            ))}
                        </Dropdown>
                    </div>
                )}
                <div className="average-based-calculator-form__item average-based-calculator-form__item--action">
                    <div className="average-based-calculator-form__action">
                        <Button
                            className="average-based-calculator-form__submit button button--primary"
                            onClick={onSubmit}
                            loading={loading}
                        >
                            <span className="button-text">
                                {i18n.translate("showData")}
                            </span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VictorAverageBasedCalculatorForm;


